import {Injectable} from '@angular/core';
import {Loan} from '../../../model/loan.model';
import {LoanStatus, LoanStatusType} from '../../../model/loan-status.model';
import {LoanApplications} from '../../../model/loan-applications.model';
import {LoanApplicationPipelineStage, LoanApplicationTransition} from '../../../model/LoanApplicationTransition';
import {isNullOrUndefined} from 'util';
import {ZipLoanStatus} from '../../../model/ZipLoanStatus.model';
import {CommonUtil} from '../../../utils/common.util';

@Injectable()
export class LoansAndApplicationsSegregator {

    public filterActiveLoans(loans: Loan[]): Loan[] {
        return loans.filter(loan => LoanStatus.isActiveAndDisbursed(loan.loan_sanction_status));
    }

    public filterCompletelyRepaidLoans(loans: Loan[]): Loan[] {
        return loans.filter(loan => LoanStatus.hasBeenCompletelyRepaid(loan.loan_sanction_status));
    }

    public filterActiveApplications(applications: LoanApplications, loans: Loan[], transitions: LoanApplicationTransition[]): LoanApplications {
        return applications.filter(application => {
            const transition = transitions.find(t => t.entityId === application.id &&
                t.toStage === LoanApplicationPipelineStage.Rejection);
            const loanForApplication = loans.find(loan => loan.loanApplicationId === application.id);
            return (loanForApplication && ZipLoanStatus.isZipDisbursedLoan(loanForApplication.loan_sanction_status, loanForApplication.loan_disbursal_status))? false : (isNullOrUndefined(transition) && (!loanForApplication || !this.isApplicationCompletelyProcessed(loanForApplication.loan_sanction_status)));
        });
    }

    public filterYetToBeSubmittedLoanApplications(loanApplications: LoanApplications,
                                                  transitions: LoanApplicationTransition[]): LoanApplications {
        return loanApplications.filter(loanApplication => {
            const transitionsForLoanApplication = transitions.find(transition => transition.entityId === loanApplication.id);
            return CommonUtil.isEmpty(transitionsForLoanApplication);
        });
    }

    public filterAcceptedButYetToBeDisbursedApplications(loans: Loan[]): Loan[] {
        return loans.filter(loan => LoanStatus.isAcceptedButYetToBeDisbursed(loan.loan_sanction_status));
    }

    public filterOldRejectedLoanApplications(applications: LoanApplications, loans: Loan[], transitions: LoanApplicationTransition[]): LoanApplications {
        return applications.filter(application => {
            const loanForApplication = loans.find(loan => loan.loanApplicationId === application.id);
            const transition = transitions.find(t => t.entityId === application.id &&
                t.toStage === LoanApplicationPipelineStage.Rejection);
            return transition !== undefined ||
                (loanForApplication !== undefined && this.isApplicationClosedOrRejected(loanForApplication.loan_sanction_status));
        });
    }

    private isApplicationCompletelyProcessed(status: LoanStatusType): boolean {
        return LoanStatus.isRejected(status) || LoanStatus.hasBeenDisbursed(status) || LoanStatus.hasBeenCompletelyRepaid(status) ||
            LoanStatus.hasBeenClosedBeforeDisbursal(status);
    }

    private isApplicationClosedOrRejected(status: LoanStatusType): boolean {
        return LoanStatus.isRejected(status) || LoanStatus.hasBeenClosedBeforeDisbursal(status);
    }
}
